// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-n_hu","advertDetailServiceList__header":"c-n_hv","advertDetailServiceList__list":"c-n_hw"};